import { VitalSignEntry } from 'src/app/interfaces/vital-signs/vital-sign-entry';
import {LightUser} from '../../interfaces/core/light-user';
import {LightUserFactory} from '../core/light-user-factory';
import {UserService} from '../../services/core/user.service';
import {LightEmployee} from '../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {VitalSignContext} from '../../interfaces/vital-signs/vital-sign-context';
import {VitalSignContextFactory} from './vital-sign-context-factory';

export class VitalSignEntryFactory {

  public static fromObject(vitalSignEntry: any): VitalSignEntry {
    return new class implements VitalSignEntry {
      vitalSignTypeId: number = vitalSignEntry.vital_sign_type_id;
      vitalSignOptionId: number = vitalSignEntry.vital_sign_option_id;
      vitalSignContextId: number = vitalSignEntry.vital_sign_context_id;
      contextOther: string = vitalSignEntry.context_other;
      vitalSignContext: VitalSignContext = vitalSignEntry.vital_sign_context ?
        VitalSignContextFactory.fromObject(vitalSignEntry.vital_sign_context) : null;
      customerId: number = vitalSignEntry.customer_id;
      employeeId: number = vitalSignEntry.employee_id;
      employee: LightEmployee = LightEmployeeFactory.fromObject(vitalSignEntry.employee);
      userId: number = vitalSignEntry.user_id;
      value1: number = vitalSignEntry.value1;
      value2: number = vitalSignEntry.value2;
      value3: number = vitalSignEntry.value3;
      comment: string = vitalSignEntry.comment;
      measuredAt: string = vitalSignEntry.measured_at;
      user: LightUser = LightUserFactory.fromObject(vitalSignEntry.user);
      // ---------------------------------------------------------------------------------------------------------------
      id: number = vitalSignEntry.id;
      uuid: string = vitalSignEntry.uuid;
      modified: string = vitalSignEntry.modified;
      created: string = vitalSignEntry.created;
      deleted: 0 | 1 = 0;
    };
  }

  public static new(vitalSignEntry: Partial<VitalSignEntry>): VitalSignEntry {
    return new class implements VitalSignEntry {
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
      deleted: 0 | 1 = 0;
      vitalSignTypeId: number = vitalSignEntry.vitalSignTypeId || null;
      vitalSignOptionId: number = vitalSignEntry.vitalSignOptionId || null;
      vitalSignContextId: number = vitalSignEntry.vitalSignContextId || null;
      vitalSignContext: VitalSignContext = vitalSignEntry.vitalSignContext || null;
      contextOther: string = vitalSignEntry.contextOther || null;
      customerId: number = vitalSignEntry.customerId || null;
      employeeId: number = UserService.getUser().employee.id;
      employee: LightEmployee = UserService.getUser().employee;
      userId: number = UserService.getUser().id;
      value1: number = vitalSignEntry.value1 || null;
      value2: number = vitalSignEntry.value2 || null;
      value3: number = vitalSignEntry.value3 || null;
      comment: string = vitalSignEntry.comment || null;
      measuredAt: string = vitalSignEntry.measuredAt || null;
      user: LightUser = UserService.getUser();
    };
  }

  public static fromArray(vitalSignEntries: any[]): VitalSignEntry[] {
    return vitalSignEntries.map(VitalSignEntryFactory.fromObject);
  }

  public static toRemote(vitalSignEntry: Partial<VitalSignEntry>): any {
    return {
      id: vitalSignEntry.id,
      uuid: vitalSignEntry.uuid,
      modified: vitalSignEntry.modified,
      created: vitalSignEntry.created,
      vital_sign_type_id: vitalSignEntry.vitalSignTypeId,
      vital_sign_option_id: vitalSignEntry.vitalSignOptionId,
      vital_sign_context_id: vitalSignEntry.vitalSignContextId,
      context_other: vitalSignEntry.contextOther,
      customer_id: vitalSignEntry.customerId,
      employee_id: vitalSignEntry.employeeId,
      value1: vitalSignEntry.value1,
      value2: vitalSignEntry.value2,
      value3: vitalSignEntry.value3,
      comment: vitalSignEntry.comment,
      measured_at: vitalSignEntry.measuredAt
    };
  }
}
